import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Card from "../../components/common/Card"
import Tab from "../../components/common/Tab/Tab";

import { Container, CardWrapper } from "./CampaignsStyles";
import { getTopBoard } from "../../redux/slices/campaignSlice";

const Campaigns = () => {
  const dispatch = useDispatch();
  const { topBoard } = useSelector((state) => state.campaign);
  //console.log(topBoard);
  useEffect(() => {
    dispatch(getTopBoard());
  }, [dispatch]);
  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>My Campaigns</h3>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          <Link className="add-campaign" to="/create-campaign">
            + Create Campaign
          </Link>
        </div>
      </div>
      
      <CardWrapper>
        <Card
          text={"Total no of Campaigns"}
          totalCount={topBoard?.totalCampaigns}
        />
        <Card
          text={"Approved Campaigns"}
          totalCount={topBoard?.approvedCampaigns}
        />
        <Card text={"Pending Approvals"} totalCount={topBoard?.pendingCampaigns} />
      </CardWrapper>
      <Tab campaign />
    </Container>
  );
};

export default Campaigns;
